import React from 'react';
import { useErrorContext, ErrorBanner, ErrorDialog } from '../components/error';
import { useInfoBannerContext } from '../components/info-banner/context/info-banner-context';
import { InfoBanner } from '../components/info-banner/info-banner';
import { isInfoBannerPath } from '../components/info-banner/consts';
import { useLocation } from 'react-router-dom';

// ----------------------------------------------------------

interface BaseLayoutProps {
  children: React.ReactNode;
}

// ----------------------------------------------------------

const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  const { error, setError, bannerError, setBannerError } = useErrorContext();
  const { bannerData, bannerHidden, setBannerHidden } = useInfoBannerContext();
  const location = useLocation();

  const showInfoBanner = !bannerHidden && isInfoBannerPath(location.pathname);

  return (
    <main className="appWrapper">
      <ErrorDialog
        isOpen={!!error}
        onClose={() => setError(null)}
        errorMessage={error?.message}
        userFacingMessage={error?.userFacingMessage}
      />
      {showInfoBanner && bannerData && (
        <InfoBanner onClose={setBannerHidden} bannerData={bannerData} />
      )}
      {children}
      <ErrorBanner
        open={!!bannerError}
        onClose={() => setBannerError(null)}
        error={{
          status: bannerError?.status ?? 'Error',
          message: bannerError?.message ?? 'An error occurred',
          estimatedFixTime: bannerError?.estimatedFixTime ?? null,
        }}
      />
    </main>
  );
};

export default BaseLayout;
